import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges } from '@angular/core';
import { CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { ComponentVariantModel } from '@models/component-variant';
import { ConfigurationModel } from '@models/configuration';
import { CustomizerMenuPartModel } from '@models/customizer-menu-part';
import { MiscModel } from '@models/misc-model';
import { ModelGroupModel } from '@models/model-group';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigurationService } from '@services/configuration.service';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ModelsService } from '@services/v2/models.service';
import { ModalService } from '../../../../_services/modal.service';
import { NavigateService } from '../../../../_services/navigate.service';
import { CustomizerStateConstants } from '../../../../shared/customizer-state-constants';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
	selector: 'extra-innerrim',
	styleUrls: ['./extra-innerrim.scss'],
	template: `
      <customizer-component-header class="header"
        [menu]="menu"
        (updateCollapsedOnComponent)="updateCollapsed($event)"
        [overrideTranslateName]="'CUSTOMIZER.COMPONENTS.EXTRAINNERRIM.HEADER'">
        <div class="flex flex-grow flex-column has-padding-horizontal-30px">
          <div class="flex flex-grow flex-column inline-scroll">
            @if (!showInfoWhenNewOrder) {
              <p [innerHTML]="'CUSTOMIZER.COMPONENTS.EXTRAINNERRIM.INFO1' | translate"></p>
            }
            @if (!showInfoWhenNewOrder) {
              <div class="innerrim-container">
                <img class="innerrim-picture" [src]="'/assets/images/extra_innerrim/extra_innerrim.png'" [alt]="'CUSTOMIZER.COMPONENTS.EXTRAINNERRIM.INFO1' | translate" />
              </div>
            }
            @if (showInfoWhenNewOrder) {
              <p [innerHTML]="'CUSTOMIZER.COMPONENTS.EXTRAINNERRIM.INFO3' | translate"></p>
            }
            <p [innerHTML]="'CUSTOMIZER.COMPONENTS.EXTRAINNERRIM.INFO2' | translate"></p>
          </div>
          <div>
            <button (click)="goToExtraInnerRim()" class="add-rims-button btn btn-primary btn-block">{{'CUSTOMIZER.COMPONENTS.EXTRAINNERRIM.ADDRIMS' | translate}}</button>
            @if (showInfoWhenNewOrder || state === customizerStateConstants.ADDEDORDER) {
              <button id="norims" (click)="noRims()" class="add-rims-button btn btn-secondary btn-block">{{'CUSTOMIZER.COMPONENTS.EXTRAINNERRIM.NORIMS' | translate}}</button>
            }
          </div>
        </div>
      </customizer-component-header>
      `,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CustomizerComponentHeaderComponent, TranslatePipe]
})
export class ExtraInnerrimComponent extends BaseCustomizerComponent implements OnChanges {

	public showInfoWhenNewOrder: boolean = false;
	public customizerStateConstants = CustomizerStateConstants;

	constructor(
		public override events: EventsService,
		public navigateService: NavigateService,
		public modalService: ModalService,
		public dataService: DataApiService,
		private modelsService: ModelsService,
		public override configurationService: ConfigurationService
	) {
		super(events, dataService, configurationService);
	}

	public static override shouldBeVisible = (modelGroup: ModelGroupModel | undefined, menuComponents: CustomizerMenuPartModel, variants: Array<ComponentVariantModel> | undefined, configurations: Array<ConfigurationModel>, demo: boolean, chosenCase?: MiscModel | null): boolean => {
		return true;
	}

	async initData() {
	}

	onChanges(changes: SimpleChanges): void {
		if (changes['state'] && changes['state'].currentValue != CustomizerStateConstants.NEWORDER) {
			this.showInfoWhenNewOrder = false;
		}
	}

	async goToExtraInnerRim() {
		if (this.state == CustomizerStateConstants.NEWORDER && !this.showInfoWhenNewOrder) {
			this.showInfoWhenNewOrder = true;
			return;
		}

		this.events.showLoader(true);
		const modelGroup = await this.modelsService.getModelGroup(this.modelGroup.ParentModelGroupUuid);

		const modelGroupChild = modelGroup?.ModelGroupChildren.find(x => !x?.FullFrame);

		await this.navigateService.navigateToCustomizer(modelGroupChild, this.model, this.modelSize);
	}

	async noRims() {
		this.updateCurrentMainComponent(null);
	}

}
